// extracted by mini-css-extract-plugin
export default {"Preloader":"Preloader_Preloader__47YRx","icon":"Preloader_icon__jyXvM","text":"Preloader_text__597X4"};